import React, { useEffect, FC } from "react";
import { ITopType } from "@/types/ScmTypes";
import { Button } from "antd";
import { YhFormBox } from "@/components/YhFormBoxVertical";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBoxVertical/Types"; import useNavModel from "@/model/navModel";
import { useEntryDetailsModel } from "./stockEntryModelDetails"
import { DetailType } from "@/types/ScmEnums";
import { YHDetailNav } from "@/components/YHDetailNav";
export const FormBox: FC<ITopType> = ({ id, mode, parentInfo, IFormRef }) => {
    const { selectedNavId, replaceNav } = useNavModel();
    const { detailLookForm, getDetailLookOne } = useEntryDetailsModel()
    useEffect(() => {
        mode === DetailType.look && getDetailLookOne(id, mode)

    }, [mode, id])
    const goBack = () => {
        replaceNav(selectedNavId, "9-5")
    }
    const rightChildren = <>
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={goBack}
        >返回</Button>
    </>
    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        // style: { padding: "18px 0 0 0", marginBottom: "15px" },
        // contentClass: "pr-77",
        // rightChildren,
        items: [
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "单据编号",
            //     fieldName: "tradeCode",
            //     disable: true,
            // },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "单据类型",
                fieldName: "tradeTypeName",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单员",
                fieldName: "billingClerk",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单时间",
                fieldName: "billingTime",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "库管员",
                fieldName: "createUser",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "入库时间",
                fieldName: "createTime",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "单位名称",
                fieldName: "userName",
            }
        ]
    }
    const onChange = () => {

    }
    const poFromConfig: IYhFormBox = {
        formRef: IFormRef,
        labelCol: { span: 6 },
        disabled: true,
        labelAlign: "right",
        formValues: detailLookForm,
        onChange,
        boxs: [baseFormItem]
    }
    return (
        <>
            <YHDetailNav
                title={
                    <span>
                        单据编号:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{detailLookForm.tradeCode ?? "暂无"}</span>
                    </span>
                }
                btns={rightChildren}
                style={{ marginBottom: '6px' }}
            />
            <YhFormBox {...poFromConfig} />
        </>
    )
}
